import React, { useEffect, useState } from "react";
import { FaXmark } from "react-icons/fa6";
import { VscRefresh } from "react-icons/vsc";
import {
  RiSkipUpLine,
  RiArrowUpSLine,
  RiArrowDownSLine,
  RiSkipDownLine,
} from "react-icons/ri";
import { useGetFiltersOptionsMutation } from "../../../dataApiSlice";
import { useSelector } from "react-redux";
import { getL1SheetProperty } from "../../../WorkbookSlice";

export default function CustomSort({
  closeModal,
  item,
  Sheetid,
  sortLevel,
  setSortLevel,
  selectedRow,
}) {
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );
  const [getFiltersOptions, { data, isSuccess }] =
    useGetFiltersOptionsMutation();
  const [allOptionsData, setAllOptionsData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  // console.log(allOptionsData);

  useEffect(() => {
    if (item) {
      let filterBody;
      if (item.dataType === "Date" && item?.dateFormat.value) {
        filterBody = {
          databaseID: dataSourceID,
          columns: [{ name: item.columnName, format: item?.dateFormat.value }],
        };
      } else {
        filterBody = {
          databaseID: dataSourceID,
          columns: [{ name: item.columnName }],
        };
      }
      if (!data) {
        getFiltersOptions({filterBody, calledFrom : "customSort"});
      }
    } else {
      // console.log("item is undefined");
    }
  }, [item, dataSourceID]);

  useEffect(() => {
    if (isSuccess) {
      const options = Object.values(data ?? {})[0]?.map((value) => value) ?? [];
      setAllOptionsData(options);
    }
  }, [data, isSuccess]);

  const handleClear = () => {
    const options = Object.values(data ?? {})[0]?.map((value) => value) ?? [];
    setAllOptionsData(options);
  };

  const handleValueSelection = (index) => {
    setSelectedValue(index === selectedValue ? null : index);
  };

  const handleTop = () => {
    if (selectedValue !== null) {
      const newArray = [...allOptionsData];
      const [selectedItem] = newArray.splice(selectedValue, 1);
      newArray.unshift(selectedItem);
      setAllOptionsData(newArray);
      setSelectedValue(0);
    }
  };

  const handleBottom = () => {
    if (selectedValue !== null) {
      const newArray = [...allOptionsData];
      const [selectedItem] = newArray.splice(selectedValue, 1);
      newArray.push(selectedItem);
      setAllOptionsData(newArray);
      setSelectedValue(newArray.length - 1);
    }
  };

  const handleUp = () => {
    if (selectedValue !== null && selectedValue > 0) {
      const newArray = [...allOptionsData];
      [newArray[selectedValue - 1], newArray[selectedValue]] = [
        newArray[selectedValue],
        newArray[selectedValue - 1],
      ];
      setAllOptionsData(newArray);
      setSelectedValue(selectedValue - 1);
    }
  };

  const handleDown = () => {
    if (selectedValue !== null && selectedValue < allOptionsData.length - 1) {
      const newArray = [...allOptionsData];
      [newArray[selectedValue + 1], newArray[selectedValue]] = [
        newArray[selectedValue],
        newArray[selectedValue + 1],
      ];
      setAllOptionsData(newArray);
      setSelectedValue(selectedValue + 1);
    }
  };

  const handleOk = () => {
    // Ensure selectedRow is within bounds and sortLevel has at least selectedRow index
    if (selectedRow >= 0 && selectedRow < sortLevel.length) {
      // Create a copy of sortLevel to avoid mutating the original
      const updatedSortLevel = [...sortLevel];
      
      // Update the specific index with the new customOrder
      updatedSortLevel[selectedRow] = {
        ...updatedSortLevel[selectedRow],
        customOrder: allOptionsData
      };
      
      // Update the state
      setSortLevel(updatedSortLevel);
      
      // Close the modal
      closeModal();
    } else {
      console.error("Selected row is out of bounds");
    }
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleOk(); // Call your function here
    }
  }

  return (
    <main className="fixed inset-0 bg-opacity-50 flex flex-col items-center justify-center z-40"  onKeyDown={handleKeyDown}>
      <main className="w-[22rem] h-auto bg-white shadow-2xl rounded-lg gap-2">
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg">
          <button className="text-lg font-medium flex items-center justify-start gap-2">
            Custom Sort
          </button>
          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-black"
          >
            <FaXmark />
          </button>
        </header>
        <section className="p-2 h-60 w-full flex items-center justify-between">
          <div className="ml-1 p-2 h-full w-[75%] border rounded overflow-y-auto flex flex-col items-start justify-start">
            {allOptionsData.map((item, index) => (
              <button
                key={index}
                className={` rounded-sm w-full text-left p-[2px] ${
                  selectedValue === index
                    ? "bg-blue-950 text-white"
                    : index % 2 === 0
                    ? "bg-none text-black"
                    : "bg-gray-200"
                }`}
                onClick={() => handleValueSelection(index)}
              >
                {item}
              </button>
            ))}
          </div>
          <div className="flex flex-col gap-4 h-full w-[25%] items-center justify-start">
            <button
              className={`border rounded p-[2px] ${
                selectedValue === null ? "opacity-50" : ""
              }`}
              disabled={selectedValue === null}
              onClick={handleTop}
            >
              <RiSkipUpLine className="text-[25px]" />
            </button>
            <button
              className={`border rounded p-[2px] ${
                selectedValue === null ? "opacity-50" : ""
              }`}
              disabled={selectedValue === null}
              onClick={handleUp}
            >
              <RiArrowUpSLine className="text-[25px]" />
            </button>
            <button
              className={`border rounded p-[2px] ${
                selectedValue === null ? "opacity-50" : ""
              }`}
              disabled={selectedValue === null}
              onClick={handleDown}
            >
              <RiArrowDownSLine className="text-[25px]" />
            </button>
            <button
              className={`border rounded p-[2px] ${
                selectedValue === null ? "opacity-50" : ""
              }`}
              disabled={selectedValue === null}
              onClick={handleBottom}
            >
              <RiSkipDownLine className="text-[25px]" />
            </button>
          </div>
        </section>
        <footer className="w-full flex items-center justify-between p-3 bg-gray-50 rounded-b-lg">
          <button
            className="flex items-center justify-center gap-2 w-20"
            onClick={handleClear}
          >
            <VscRefresh /> clear
          </button>
          <button
            className="border bg-blue-950 text-white w-20"
            onClick={handleOk} // Updated to use handleOk
          >
            Ok
          </button>
        </footer>
      </main>
    </main>
  );
}
